const MIME_TYPE_NAME = {
  'application/pdf': '.pdf',
  'text/plain': '.txt',
  'text/markdown': '.md',
  'text/html': '.html',
  'text/csv': '.csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/json': '.json',
  'application/epub+zip': '.epub',
  'text/org': '.org',
  'text/x-rst': '.rst',
  'image/jpeg': '.jpg/jpeg',
  'image/png': '.png',
};

export function formatBytesHelper(bytesSize) {
  const isFalsy = !bytesSize;
  const isNotNumber = typeof bytesSize !== 'number';
  const isNotSafeInteger = !Number.isSafeInteger(bytesSize);
  const isNegativeNumber = bytesSize < 0;
  const isZero = bytesSize === 0;

  if ((isFalsy && !isZero) || isNotNumber || isNotSafeInteger || isNegativeNumber) {
    return '';
  }

  if (isZero) return '0 Bytes';

  const kiloBytes = 1024;
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const floorUnitsIdx = Math.floor(Math.log(bytesSize) / Math.log(kiloBytes));

  let unitIdx = 0;

  if (floorUnitsIdx < 0) {
    unitIdx = 0;
  } else if (floorUnitsIdx > units.length - 1) {
    unitIdx = units.length - 1;
  } else {
    unitIdx = floorUnitsIdx;
  }

  /** this decimal depend on unit Bytes=0, KB=1, MB=2, GB=3, TB=4 */
  const parsedBytes = parseFloat((bytesSize / kiloBytes ** unitIdx).toFixed(2));

  return `${parsedBytes} ${units[unitIdx]}`;
}

export function getAcceptedExtensions(mimeTypes) {
  if (!Array.isArray(mimeTypes)) return []; // Guard clause for invalid input

  const extensions = [];
  for (const mimeType of mimeTypes) {
    const mimeName = MIME_TYPE_NAME[mimeType];
    if (mimeName) {
      for (const extension of mimeName.split('/')) {
        extensions.push(extension.startsWith('.') ? extension : `.${extension}`);
      }
    }
  }

  return extensions;
}

export function isAcceptedFileType(file, mimeTypes) {
  if (!Array.isArray(mimeTypes)) return false; // Guard clause for invalid input
  if (mimeTypes.includes(file.type)) return true;

  const filename = file.name || '';
  const extension = `.${filename.split('.').pop().toLowerCase()}`;
  return getAcceptedExtensions(mimeTypes).includes(extension);
}

export function resolveMimeTypeName(mimeTypes) {
  if (!Array.isArray(mimeTypes)) return ''; // Guard clause for invalid input

  const matchedNames = [];

  for (const mimeType of mimeTypes) {
    const mimeName = MIME_TYPE_NAME[mimeType];
    if (mimeName) {
      matchedNames.push(mimeName);
    }
  }

  if (matchedNames.length <= 0) return '';

  if (matchedNames.length === 1) return matchedNames[0];

  return `${matchedNames.slice(0, -1).join(', ')} or ${matchedNames.at(-1)}`;
}
